import { render } from "./SessionSettings.vue?vue&type=template&id=59dbe834&ts=true"
import script from "./SessionSettings.vue?vue&type=script&lang=ts"
export * from "./SessionSettings.vue?vue&type=script&lang=ts"

import "./SessionSettings.vue?vue&type=style&index=0&id=59dbe834&lang=scss"

import exportComponent from "/home/node/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__